<template>
  <div class="wrapper hefei-bg-f5">
    <!-- <div class="guide-search">
      <div class="search-cont" :class="{focus: isFocus || content.length}">
        <div class="input-wrap">
          <input
            type="text"
            name="search"
            placeholder="搜索医院、科室、医生、疾病"
            v-model="content"
            @focus="isFocus = true"
            @input="focus"
            @blur="isFocus = false"
          />
        </div>
        <img
          v-show="this.content.length"
          @click.stop="clear"
          class="clear-input"
          src="../../assets/images/jidayi-hospital/icon-search-close.png"
        />
      </div>
    </div> -->
    <div class="container-wrap-form doc-consult">
      <div class="consult-hosp-depart">
        <!-- <div class="form-table title">
          <span class="table-left sear-type" @click="filter('hosp')" v-if="!searchKey.hosp.phospId">
            {{searchKey.hosp.name||'全部医院'}}
            <i class="arrow-down"></i>
          </span>
          <span class="table-left sear-type" @click="filter('dept')">
            {{searchKey.deptResult.deptName||'所有科室'}}
            <i class="arrow-down"></i>
          </span>
          <span class="table-left sear-type" @click="filter('online')" v-if="searchKey.hosp.phospId">
            <i class="select" :class="{'active': filterOnline}"></i>
            在线
          </span>
        </div> -->
        <div class="msg-list"
          v-infinite-scroll="loadMore"
          infinite-scroll-immediate-check="false"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10">
          <div class="msg-item" v-for="(doc,i) in doctors" :key="i">
            <div class="msg-up" @click="check(doc)">
              <div class="img-left">
                <img
                  :src="doc.imgUrl?doc.imgUrl:defaultMaleAvatarUrl"
                  alt
                  :class="{'grayscale':doc.onlineStatus!='1'}"
                  v-if="doc.gender==='1'"
                  :onerror="getDefaultAvatarUrl('1')"
                />
                <img :class="{'grayscale':doc.onlineStatus!='1'}" :src="doc.imgUrl?doc.imgUrl:defaultFemaleAvatarUrl" alt v-else :onerror="getDefaultAvatarUrl('2')"/>
                <div class="tags" v-if="doc.tags">
                  <span
                    class="tag"
                    v-for="(item,index) in doc.tags.split(',')"
                    :key="index"
                  >{{item}}</span>
                </div>
              </div>
              <div class="img-content">
                <div class="clearfix msg-info">
                  <p class="fn-fl msg-con">
                    <span>{{doc.name}}</span>
                    <i>{{doc.postName}}</i>
                    <span
                      class="is-online"
                      :class="{leave:doc.onlineStatus!='1'}"
                    >{{doc.onlineStatus==='1'?'在线':'离线'}}</span>
                  </p>
                </div>
                <p class="msg-tip">{{doc.phospName}} | {{doc.deptName}}</p>
                <p class="msg-tip">
                  <span>问诊量 {{doc.consultCnt}}</span>
                </p>
                <!-- <p class="msg-tip">擅长：发热、感冒、支气管哮喘、慢性咳嗽</p> -->
                <p class="msg-tip good">擅长：{{ doc.doctorSkill && doc.doctorSkill.replace(/^擅长/, "") || '暂无擅长描述' }}</p>
              </div>
              <div class="doc-follow" :class="{active: doc.isFollow == '1'}" @click.stop="changeActive(i)">
                <i></i>
                <span>{{ doc.isFollow == '1' ? '已关注':'关注' }}</span>
              </div>
            </div>
            <div class="form-table msg-opt">
              <span class="table-left" @click="handleConsult(doc, 'img')">
                <i class="opt-img"></i>
                {{ doc.statusImage === '1'? doc.costsImage? `${financial(doc.costsImage)}元` : '-' : '暂未开通'}}
              </span>
              <span class="table-left" @click="handleConsult(doc, 'video')">
                <i class="opt-video"></i>
                {{ doc.statusVideo === '1' ? doc.costsVideo? `${financial(doc.costsVideo)}元` : '-' : '暂未开通' }}
              </span>
            </div>
          </div>
          <div class="msg-item empty" v-if="doctors && doctors.length === 0 && loaded">
            <div class="empty-tip">暂无匹配结果</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      defaultFemaleAvatarUrl: require("../../assets/images/jidayi-hospital/icon-doctor-female.png"),
      defaultMaleAvatarUrl: require("../../assets/images/jidayi-hospital/icon-doctor-male.png"),
      defaultDeptUrl:require("../../assets/images/consult-menu/icon-default-dept.png"),
      menuShow: true,
      deptRecos: [],
      doctors: [],
      content: "",
      hosp: "",
      phospId: "",
      deptId: "",
      allLoaded: false,
      pageNo: 1,
      rows: 20,
      isConsult: '0',
      isFocus: false,
      loading: false,
      loaded: false,
      doctorInfo: {},
      filterOnline: false,
      channelType: {
        // 在线咨询
        '0': {
          'img': '01',
          'video': '02'
        },
        // 在线复诊
        '1': {
          'img': '03',
          'video': '04'
        },
      },
      costMap: {
        '01': 'costsImage', //图文问诊
        '02': 'costsVideo', //视频问诊
        '03': 'costsImage', //图文复诊
        '04': 'costsVideo'//视频复诊
      },
      timer: null
    };
  },
  created() {
    let q = this.$route.query;
    this.phospId = q.phospId;
    this.deptId = q.deptId;
    this.hosp = q.name;
    this.search();
  },
  computed: {
    ...mapGetters([
      "token",
      "platId",
      "userInfo",
      "searchKey"
    ]),
  },
  methods: {
    getDefaultAvatarUrl(gender) {
      if (gender === '1') {
        return `this.src='${this.defaultMaleAvatarUrl}'`
      } else {
        return `this.src='${this.defaultFemaleAvatarUrl}'`
      }
    },
    focus() {
      this.isFocus = true;
      this.menuShow = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.clearSearch();
      }, 200);
    },
    clearSearch(val) {
      if (val) {
        this.content = val;
      }
      this.allLoaded = false;
      this.pageNo = 1;
      this.getList(true, true);
    },
    blur() {
      this.menuShow = true;
    },
    clear() {
      this.content = "";
      this.search();
    },
    getList(isLoading, clearable) {
      this.loading = true;
      this.$http
        .getDoctorsList(
          {
            phospId: this.searchKey.hosp.phospId || "",
            // deptId: this.searchKey.deptResult.phospDeptId || "",
            // content: this.content,
            staffType:'6'
          },
          {
            pageNo: this.pageNo,
            rows: this.rows
          }
        )
        .then(res => {
          if (res && res.length > 0) {
            let doctors = clearable? res : [...this.doctors, ...res]
            if (this.filterOnline) {
              doctors = doctors.filter(v => v.onlineStatus == '1')
            }
            this.doctors = doctors;
            this.menuShow = true;
            this.pageNo++;
          } else {
            if (clearable) {
              this.menuShow = true;
              this.doctors = [];
            }
          }
          if (res.length < this.rows) {
            this.allLoaded = true; // if all data are loaded
          } else {
            this.$refs.loadmore.onBottomLoaded();
          }
          this.loading = false;
          this.loaded = true;
        }).catch(_ => {
          this.loading = false;
        })
    },
    search() {
      // if (!this.content) {
      //   return;
      // }
      console.log('search')
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.allLoaded = false;
        this.doctors = [];
        this.pageNo = 1;
        this.getList();
      }, 300);
    },
    check(doctor) {
      this.$router.push({
        name: "doctorInfo",
        query: {
          staffId: doctor.staffId,
          deptId: doctor.deptId,
          isConsult: '0'
        }
      });
    },
    filter(type) {
      if (type === "hosp") {
        this.$router.push({path: '/hospFilter', query: {fromUrl: 'result'}});
      } else if (type === 'dept') {
        this.$router.push({path: '/deptFilter', query: {fromUrl: 'result'}});
      } else if (type == 'online') {
        this.filterOnline = !this.filterOnline;
        this.clearSearch();
      }
    },
    loadMore() {
      if (this.allLoaded) {
        return;
      }
      this.getList();
    },
    unlineMessageBox(){
      this.$messagebox({
        title: "温馨提示",
        message:
          "该医生有事已离线，您现在发起咨询，医生可能无法及时响应，是否确定发起咨询？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(action => {
        if(action == "confirm"){
          this.handleConsultion();
        }
      });
    },
    handleConsult(doc, type) {
      doc.consultType = this.channelType[this.isConsult][type];
      this.doctorInfo = doc;
      const channelTypeMap = {
        'img' : 'statusImage',
        'video' : 'statusVideo'
      };
      if (this.doctorInfo[channelTypeMap[type]] === '1') {
        // 医生离线无法视频咨询
        // if (this.doctorInfo.onlineStatus === '1'){
          if (type === 'video') {
              //视频问诊先查询有无排班信息
              this.createForm()
          }
          // 医生在线、离线都可以发起图文咨询
          if (type === 'img') {
            this.createForm();
          }
        // } else {
        //   this.$toast("该医生已离线，暂时无法提供问诊服务")
        // }

      } else {
        this.$toast("暂未开通该咨询渠道")
      }

    },
    /**
     * 关闭PickerComponent
     */
     closePicker() {
      this.pickerFlag = false;
    },
    createForm() {
      this.pickerFlag = false;
      this.$http
        .checkStatus({
          consultType: this.doctorInfo.consultType,
          doctorId: this.doctorInfo.staffId,
          source: "2",
          resDate: this.doctorInfo.resTime
        })
        .then(res => {
          // 0-成功、1-您已加入同个类别候诊队列、2已加入不同类别候诊队列、其他错误码-失败
          // 0-加入队列成功，即不存在订单，直接跳转病情描述
          if (res.status === "0") {
            this.handleConsultion();
          // 1-已加入同个类别候诊队列，直接判断支付状态后跳转
          } else if (res.status === '1') {
            res.record.id && this.handleConsultInfo(res.record.id)

          // 2-已加入不同类别候诊队列
          } else if (res.status === '2') {
            this.$toast(res.msg)
          // 4-离线询问是否下单
          } else if (res.status === '4') {
            this.unlineMessageBox()
          // 其他状态码-错误
          } else {
            this.$toast(res.msg)
          }
        });
    },
    handleConsultInfo(orderNo) {
      this.$http
        .getConsultInfoByOrderNo({
          orderNo: orderNo,
          userType: "01"
        })
        .then(res => {
          this.orderStatus = res.record.status
          // 未支付跳转订单详情
          if (this.orderStatus === '00') {
            this.$router.push({
              name: "recordInfo",
              query: {
                orderNo: orderNo
              }
            })
            // 其他情况跳转IM
          } else {
            // 判断当前环境
            if (this.isMini === true) {
              wx.miniProgram.navigateTo({
                url: "/pages/imChat/main?userType="+ "01" +"&orderNo=" + orderNo + "&sessionId=" + this.$store.getters.token
              })
            } else {
              this.$router.push({
                path: "/imChat",
                query: {
                  userType: "01",
                  orderNo: orderNo,
                  // 如果是同一个服务下,sessionId可以不传
                  sessionId: this.$store.getters.token
                }
              })
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //切换关注状态
    changeActive(i) {
      let doctors = this.doctors;
      let type = doctors[i].isFollow;
      this.$http
        .followDoctor({ doctorId: doctors[i].staffId, type: type })
        .then(res => {
          doctors[i].isFollow = type == '0'? '1':'0';
          this.doctors = doctors;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //视频问诊需要查询排班信息
    handleConsultion() {
      if (this.doctorInfo.consultType === '02') {
        this.$http.getSchedulList({
          consultType: "02",
          deptId: this.doctorInfo.deptId,
          doctorId: this.doctorInfo.staffId,
          hospId: this.doctorInfo.phospId
        }).then(res => {
          if(res.length > 0) {
            this.pickerDataList = res;
            this.pickerFlag = true;
          } else {
            this.enterConsultion();
          }
        })
      } else {
        this.enterConsultion();
      }
    },
    //进入问诊页面
    enterConsultion() {
      let doc = this.doctorInfo;
      this.$router.push({
        name: "counsulation",
        query: {
          deptId: doc.deptId,
          deptName: doc.deptName,
          doctorId: doc.staffId,
          doctorName: doc.name,
          doctorProfessional: doc.postName,
          hospId: doc.phospId,
          hospName: doc.phospName,
          money: doc[this.costMap[doc.consultType]],
          consultType: doc.consultType,
          resTime: doc.resTime,
          numberId: doc.numberId,
          lockType: '02'
        }
      })
    },
    //保留小数点两位
    financial(x) {
      return Number.parseFloat(x).toFixed(2);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/freeClinic.vue